import { gql } from '@apollo/client'

export const CREATE_BLOG_POST_MUTATION = gql`
  mutation createBlogPost($attributes: BlogPostInput!) {
    createBlogPost(attributes: $attributes) {
      id
      title
      subtitle
      content
      pinned
      categories
    }
  }
`
